export const BENEFITS_KEY_OVERRIDES = {
  sbcUrl: 'SBCUrl',
  sbcLinks: 'SbcLinks',
  carrierCSN: 'CarrierCSN',
  hsaSwap: 'HSASwap',
  hsaPartialBundle: 'HSAPartialBundle',
  hsapartialBundle: 'HSAPartialBundle',
  hsaCobra: 'HSACobra',
  hsaMath: 'HSAMath',
  hraAdminFee: 'HRAAdminFee',
  bundleHSABenefits: 'BundleHSABenefits',
  isHsa: 'IsHsa',
  vcnStatus: 'VCNStatus',
  hixmeAccidentGroupId: 'HixmeAccidentGroupId',
  pcp: 'PCP',
  pcpId: 'PCPId',
  ssn: 'SSN',
  ssnEncrypted: 'SSNEncrypted',
  ssnHmac: 'SSNHmac',
  ssnLastFour: 'SSNLastFour',
  smsOptIn: 'SMSOptIn',
}
